/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class RoleApi {
    static getInstance() {
        if (!this.instance) this.instance = new RoleApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取角色列表
    async getRoleList (param){
        let url = `/api/role/list`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取用户列表
    async getUserList (param,num,size){
        let url = `/api/user/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 角色绑定按钮权限
    async roleAuth (param,role_ids){
        let url = `/api/role/menu/saveBatch?role_ids=${role_ids}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 用户绑定角色
    async userRole (param){
        let url = `/api/user/role`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增按钮
    async addBtn (param){
        let url = `/api/menu`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 根据角色查询菜单和按钮
    async getMenuBtnByRole (id){
        let url = `/api/menu/role/menus?role_ids=${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }
    
    // 删除用户角色
    async delUserRole (roleId,userId){
        let url = `/api/user/role/delete/roles?role_ids=${roleId}&user_id=${userId}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 添加邮箱
    async addEmail (param){
        let url = `/api/system/dict/sub`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取邮箱列表
    async getList (param,num,size){
        let url = `/api/system/dictionary/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 删除邮箱
    async delEmail (id){
        let url = `/api/system/dict/sub/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }


    // 获取菜单列表
    async getMenu (){
        let url = `/api/menu`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 新增菜单
    async addMenu (param){
        let url = `/api/menu`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 编辑菜单
    async editMenu (param,id){
        let url = `/api/menu/${id}`
        let result = await this.getData(url,param,'PATCH')
        return result
    }

    // 删除菜单
    async deleteMenu (id){
        let url = `/api/menu/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

}

export {
    RoleApi
}